import { Button } from 'antd';

import './index.css';

interface SwiperLayoutProps {
  ids: string[];
  currentIndex: number;
  children: React.ReactNode;
  onChange: (index: number) => void;
}

const SwiperLayout = ({
  ids,
  currentIndex,
  children,
  onChange,
}: SwiperLayoutProps) => {
  const handlePrevClick = () => {
    const newIndex = currentIndex - 1;
    if (newIndex >= 0) {
      onChange(newIndex);
    }
  };

  const handleNextClick = () => {
    const newIndex = currentIndex + 1;
    if (newIndex < ids.length) {
      onChange(newIndex);
    }
  };

  return (
    <div className="swiper-layout-container">
      <div className="pagination-btn-container">
        <Button
          type="primary"
          className="pagination-btn-left"
          onClick={handlePrevClick}
          disabled={currentIndex === 0}
          shape="circle"
        >
          &lt;
        </Button>
      </div>

      <div className="swiper-item-container">{children}</div>

      <div className="pagination-btn-container">
        <Button
          type="primary"
          className="pagination-btn-right"
          onClick={handleNextClick}
          disabled={currentIndex === ids.length - 1}
          shape="circle"
        >
          &gt;
        </Button>
      </div>
    </div>
  );
};

export default SwiperLayout;
